export default function (
  filtersForm: Element,
  inputSelector: string,
  changeCallback?: (() => void) | null,
  clickCallback?: ((el?: Element) => void) | null
): void {
  const moreFiltersEl = document.getElementById('more-filters')
  const recapListEl = document.getElementById('search-filters-recap-list')

  if (recapListEl) {
    recapListEl.addEventListener('click', (e) => {
      const target = e.target as Element

      if (!target) {
        return
      }

      if (target.classList.contains('dca-recap__item') || target.classList.contains('dca-recap__action')) {
        if (clickCallback) {
          clickCallback(target)
        }
      }
    })

    recapListEl.querySelectorAll<HTMLElement>('.dca-recap__item[data-type="search"][data-target]').forEach(function (el) {
      const target = document.getElementById(el.getAttribute('data-target') as string) as HTMLElement

      if (target) {
        target.addEventListener('change', function (this: HTMLSelectElement) {
          let value = this.innerText || this.value

          if (this.options?.[this.selectedIndex]) {
            value = this.options[this.selectedIndex]?.text as string
          }

          const placeholder = (this.getAttribute('data-placeholder') as string) || (this.getAttribute('placeholder') as string)

          ;(el.querySelector('.dca-recap__item-value') as HTMLElement).innerHTML = value || placeholder

          if (value) {
            el.classList.add('dca-recap__item--selected')
          } else {
            el.classList.remove('dca-recap__item--selected')
          }
        })
      }
    })
  }

  if (moreFiltersEl && recapListEl) {
    const removeFilterFn = function (this: Node): void {
      if (!filtersForm) {
        return
      }

      if ((this.parentNode as HTMLElement).hasAttribute('data-target')) {
        document.getElementById((this.parentNode as HTMLElement).getAttribute('data-target') as string)?.click()
        filtersForm.querySelector<HTMLButtonElement>('[type="submit"]')?.click()
      }
    }

    moreFiltersEl.addEventListener('click', function (this: Element, e) {
      e.preventDefault()

      if (clickCallback) {
        clickCallback(this)
      }
    })

    recapListEl.querySelectorAll('.dca-recap__item-reset').forEach(function (el) {
      el.addEventListener('click', removeFilterFn)
    })

    const itemClone = recapListEl.querySelector('.dca-recap__item')?.cloneNode(true)
    let totalFilters = parseInt(moreFiltersEl.getAttribute('data-total') as string, 10)

    if (filtersForm && inputSelector) {
      filtersForm.querySelectorAll<HTMLInputElement>(inputSelector).forEach(function (el) {
        const filterChangeFn = function (): void {
          if (changeCallback) {
            changeCallback()
          }

          const labelEl = el.nextElementSibling?.querySelector('.filter__label') as HTMLElement
          const label = labelEl.innerText

          if (el.checked) {
            const itemEl = itemClone?.cloneNode(true) as HTMLElement
            itemEl.classList.add('dca-recap__item--selected')
            itemEl.setAttribute('data-target', el.id)
            itemEl.setAttribute('data-types', 'filters')

            const itemValueEl = itemEl.querySelector('.dca-recap__item-value') as HTMLElement
            itemValueEl.setAttribute('data-field', el.value)
            itemValueEl.innerText = label

            const resetEl = document.createElement('span')
            resetEl.className = 'dca-recap__item-reset'

            resetEl.addEventListener('click', removeFilterFn)

            itemEl.appendChild(resetEl)
            recapListEl.appendChild(itemEl)

            totalFilters++
          } else {
            const recapEl = recapListEl.querySelector(`.dca-recap__item[data-target="${el.id}"]`)

            if (recapEl) {
              recapListEl.removeChild(recapEl)
              totalFilters--
            }
          }

          moreFiltersEl.setAttribute('data-total', totalFilters.toString())
        }

        el.addEventListener('change', filterChangeFn)
      })
    }
  }
}
